// extracted by mini-css-extract-plugin
export var headerCell = "_4u-1";
export var loadingSpinnerContainer = "_4u-4";
export var rowWrapper = "_4u-3";
export var standaloneTable = "_4u-5";
export var table = "_4u-0";
export var white = "_4u-2";